export const requestApp = (type: string, data?: any) => {
    if (!window.ReactNativeWebView) return; // 웹뷰가 아닐 경우에는 return
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type, data: data || {} }))
}

export const APP_TO_WEB = {
    INSET_INFO: "INSET_INFO",
    DEVICE_INFO: "DEVICE_INFO",
    SEND_TOKEN: "SEND_TOKEN",
    /** 푸시 로컬라이제이션 문구 맵 (data: { [locKey]: template }).
     *   푸시 이력에는 loc-key 와 치환 인자만 저장돼 있고(서버는 수신자 언어를 모른다),
     *   실제 문구는 앱이 가진 원본에 있다. 서비스마다 키 집합이 달라 공통 프론트가 키를 알 수 없으므로
     *   앱이 현재 언어의 맵을 주입해 준다. */
    SEND_PUSH_LOC_STRINGS: "SEND_PUSH_LOC_STRINGS",
}

export const WEB_TO_APP = {
    LOGS: "LOGS",
    MSG_READY : "MSG_READY",
    /** 토큰이 없을 때 앱에 다시 달라고 요청. 앱은 로그아웃 상태여도 빈 값으로 답한다. */
    REQUEST_TOKEN: "REQUEST_TOKEN",
    LOADING: "LOADING",
    CLOSE_POPUP: "CLOSE_POPUP",
}

export const closePopup = () => {
    // RN WebView: 네이티브 측 종료 요청
    if (window.ReactNativeWebView) {
        requestApp(WEB_TO_APP.CLOSE_POPUP, {});
        return;
    }
    // iframe 진입(예: DOKOCREW 설정 모달): 부모창에 닫기 요청 — 부모가 모달 close 처리
    if (typeof window !== 'undefined' && window.parent !== window) {
        try {
            window.parent.postMessage(JSON.stringify({ type: WEB_TO_APP.CLOSE_POPUP, data: {} }), '*');
        } catch {
            // 포스트 실패는 무시
        }
    }
}

// 네이티브에서 받은 이벤트 가공
export const msgData = (event: MessageEvent) => {
    const originData = event?.data;
    if (!originData) return { type: undefined, data: undefined };

    let response;
    try {
        response = JSON.parse(originData || '{}');
    } catch (error) {
        return { type: undefined, data: undefined };
    }

    const type = (response?.type as string)?.toUpperCase();
    let data = response.data;
    try {
        data = JSON.parse(response.data);
    } catch (error) {
        data = response.data;
    }

    return { type, data };
}
